<div class="container-fluid p-0 edit-profile-page">

    <!-- HEADER -->
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
    />

    <!-- MAIN -->
    <section class="container py-4 profile-shell">
        <div class="card profile-editor-card rounded-4 overflow-hidden">
            <form @submit.prevent="saveProfile">
                <div class="row g-0">
                    <div class="col-lg-4">
                        <div class="profile-editor-aside">
                            <span class="profile-kicker mb-4">Account settings</span>
                            <div class="profile-avatar profile-avatar-lg d-flex align-items-center justify-content-center">
                                <span class="profile-avatar-text">{{ avatar_initials }}</span>
                            </div>

                            <div class="profile-editor-summary">
                                <div class="profile-editor-summary-item">
                                    <span class="profile-contact-label">First name</span>
                                    <strong class="text-dark">{{ form.first_name || 'Not set' }}</strong>
                                </div>
                                <div class="profile-editor-summary-item">
                                    <span class="profile-contact-label">Last name</span>
                                    <strong class="text-dark">{{ form.last_name || 'Not set' }}</strong>
                                </div>
                                <div class="profile-editor-summary-item">
                                    <span class="profile-contact-label">Email address</span>
                                    <strong class="text-dark">{{ form.email || 'Not set' }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-8">
                        <div class="profile-editor-main">
                            <div class="profile-editor-header">
                                <div>
                                    <span class="profile-section-eyebrow">Update your details</span>
                                </div>
                            </div>

                            <div class="row g-4">
                                <div class="col-md-6">
                                    <label class="form-label profile-form-label">First Name</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-dark profile-form-control"
                                        v-model="form.first_name"
                                        required
                                    >
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label profile-form-label">Last Name</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-dark profile-form-control"
                                        v-model="form.last_name"
                                        required
                                    >
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label profile-form-label">Email Address</label>
                                    <div class="profile-readonly-field">
                                        <i class="bi bi-lock me-2"></i>
                                        <input
                                            type="email"
                                            class="form-control form-control-dark profile-form-control profile-readonly-input"
                                            v-model="form.email"
                                            readonly
                                        >
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label profile-form-label">Phone Number</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        pattern="[0-9]{10}"
                                        placeholder="0123456789"
                                        class="form-control form-control-dark profile-form-control"
                                        v-model="form.phone"
                                        required
                                    >
                                </div>
                            </div>

                            <div class="profile-editor-actions">
                                <button
                                    type="button"
                                    class="btn profile-secondary-btn"
                                    @click="cancelEdit"
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    class="btn btn-primary profile-primary-btn"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>

</div>
